import { http } from "services";

// TODO Implement api requests
export const List = ({ params }) => http.request.post(`/v1/gov-function/open/register-requirement/pageable${params.okedId ? `?okedId=${params.okedId}` : ``}`, {
    per_page: params.perPage,
    page: params.page,
    sort: params.sort,
    search: params.filter
  });

export const DownloadExcel = async ({ params }) =>
  http.request.post(
    "/v1/gov-service/open/download/excel",
    {
      per_page: params.perPage,
      page: params.page,
      sort: params.sort,
      search: params.filter,
    },
    {
      responseType: "blob",
    },
  );

export const Single = async ({ id }) =>
  http.request.get(`/v1/gov-function/open/register-requirement/${id}`);


export const StatsList = ({ params }) =>
  http.request.post(
    "/v1/gov-function/open/register-requirement/organization-stats",
    {
      per_page: params.perPage,
    //   filter: params.filter,
    },
  );
